import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const LocationMarker = ({ delay, children }) => {
  return (
    <Root>
      <Marker style={{animationDelay: delay}}>
        <InfoBox>{children}</InfoBox>
      </Marker>
    </Root>
  );
};

LocationMarker.propTypes = {
  delay: PropTypes.string,
};

LocationMarker.defaultProps = {
  delay: '0',
}

const Root = styled.div`
  position: relative;
  transform: translateZ(0);
`;

const animateMarker = keyframes`
  0% {
    opacity: 0;
    transform: scale(0) translateZ(0);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateZ(0);
  }
`

const InfoBox = styled.div`
  position: absolute;
  bottom: calc(100% + 3px);
  left: 50%;
  min-width: 125px;
  display: block;
  white-space: normal;
  transform: translateX(-50%) scale(0.9) translateZ(0);
  background: #fff;
  padding: 4px 15px;
  border-radius: 12px;
  font-size: 11px;
  opacity: 0;
  transition: all 0.3s;
  &:after {
    content: '';
    position: absolute;
    top: calc(100% - 2px);
    left: 50%;
    transform: translateX(-50%);
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 10px solid #fff;
  }
`;

const Marker = styled.div`
  width: 20px;
  height: 20px;
  background: #f54629;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  opacity: 0;
  animation: ${animateMarker} 0.5s forwards;
  transform: translateZ(0);
  &:after {
    content: '';
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.65);
    transition: all 0.5s;
  }
  &:hover {
    ${InfoBox} {
      opacity: 1;
      transform: translateX(-50%) scale(1) translateZ(0);
    }
  }
`;

export default LocationMarker;



// WEBPACK FOOTER //
// ./src/components/Map/elements/LocationMarker.js